import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Main as MainLayout, } from '../../../layouts';
import configBase from '../../../configBase';
import axios from 'axios';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt';

import Paper from '@material-ui/core/Paper';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/LinearProgress';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';



class ListaPropostasPJ extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      page: '',
      titlePage: '',
      apiPage: null,
      data: 'loading',
      showTable: false,
      showColBroker: false,
      showColSalesman: false,
      showColStage: false,

      // Paginação do servidor
      currentPage: 0,
      itemsPerPage: 10,
      totalItems: 0,
      
      showDateActive: false,
      isDefaultUser: false,

      loadingTable: null,
      showSearchDate: false,
      searchField: 'fantasyName', // Default search field
      isSearching: false, // Indicador de loading durante pesquisa
      isPaginationLoading: false, // Indicador de loading durante mudanças de paginação
    };

    this.errorField = {
      
    };

    this.errorFormat = {
      
    };

    this.styles = {
      theadTr:{
        textTransform: "uppercase",
      },
      inputSearch: {
        marginLeft: 8,
        flex: 1,
      },
      theadTh:{
        height: 40,
      },
      tdDate: {
        color: 'rgb(117, 117, 117)',
        margin: 0,
        fontSize: 11,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        fontWeight: 500,
        lineHeight: '13px',
        letterSpacing: '0.33px',
        textTransform: 'uppercase',
        padding: 0,
        height: 40,
      }
    }

  }


  componentDidMount() {
    let userType = localStorage.getItem('planos_y');
    let state = this.state;

    // Verifica se exibe ou não a coluna 'Corretora'
    /* if (userType !== 'SALESMAN' && userType !== 'BROKER')
      state.showColBroker = true;
    else
      state.showColBroker = false; */

    // Verifica se exibe ou não a coluna 'Vendedor'
    if (userType === 'SALESMAN')
      state.showColSalesman = false;
    else
      state.showColSalesman = true;

    this.setState(state);
  
    this.getFilterName();
    this.getData(true);
  }

  // Função para aplicar máscara do CNPJ
  applyCnpjMask(value) {
    // Remove todos os caracteres não numéricos
    const numbers = value.replace(/\D/g, '');
    
    // Aplica a máscara: XX.XXX.XXX/XXXX-XX
    if (numbers.length <= 2) {
      return numbers;
    } else if (numbers.length <= 5) {
      return numbers.replace(/(\d{2})(\d{1,3})/, '$1.$2');
    } else if (numbers.length <= 8) {
      return numbers.replace(/(\d{2})(\d{3})(\d{1,3})/, '$1.$2.$3');
    } else if (numbers.length <= 12) {
      return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{1,4})/, '$1.$2.$3/$4');
    } else {
      return numbers.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2})/, '$1.$2.$3/$4-$5');
    }
  }

  getFilterName() {
    // pega o filtro para saber q nome exibir no titulo
    let state = this.state;
    let page = this.props.history.location.pathname;

    page = page.split('/');
    page = page[page.length - 1];

    state.page = page;

    if (page === "geralpj") {
      state.titlePage = "TODAS AS PROPOSTAS - PJ";
      state.apiPage = 'all';
    }
    else if (page === "pendentespj") {
      state.titlePage = configBase.statusPendente;
      state.apiPage = 'pjawaitingpayment';
    }
    else if (page === "confpendentespj") {
      state.titlePage = configBase.statusConfPendentePJ;
      state.apiPage = 'pjconfirmation';
    }
    else if (page === "emprocessamentopj") {
      state.titlePage = configBase.statusEmProcessamentoPJ;
      state.apiPage = 'pjprocessing';
    }
    else if (page === "indeferidaspj") {
      state.titlePage = configBase.statusIndeferidaPJ;
      state.apiPage = 'pjpending';
    }
    else if (page === "emanalisepj") {
      state.titlePage = configBase.statusEmAnalisePJ;
      state.apiPage = 'pjinvalidation';
    }
    else if (page === "implantadaspj") {
      state.titlePage = configBase.statusImplementadasPJ;
      state.apiPage = 'pjdeployed60days';
    }
    else if (page === "canceladaspj") {
      state.titlePage = configBase.statusCanceladasPJ;
      state.apiPage = 'pjcanceled60days';
    }
    else 
      state.titlePage = "PÁGINA INCORRETA";
      

    this.setState(state);
  }

  getData(table=false, searchDate=false) {
    // Para o tipo dos dados da tabela
    let typeBox = this.state.apiPage;
    let url = configBase.api + 'Companies/listByUser?access_token='+localStorage.getItem('planos_t');
    
    // Parâmetros para enviar
    let filter = {
      user: localStorage.getItem('planos_u'),
      content: typeBox,
      limit: this.state.itemsPerPage,
      skip: this.state.currentPage * this.state.itemsPerPage
    };

    // Se houver um termo de busca
    if (this.state.searchTerm) {
      filter[this.state.searchField] = this.state.searchTerm;
    }

    if (typeBox === null) {
      let state = this.state;
      state.data = 'zero';
      this.setState(state);
    }
    else {
      axios.post(url, filter)
      .then((response) => {
        let state = this.state;
        state.isSearching = false; // Finaliza o loading da pesquisa
        state.isPaginationLoading = false; // Finaliza o loading da paginação

        // Verifica o vendedor padrão
        if (response.data.salesmanDefault && response.data.salesmanDefault === true)
          state.showColSalesman = true;

        if (response.data.companys.length === 0) {
          state.data = 'zero';
          state.totalItems = 0;
        }
        else {
          this.setColorStatus(response.data.companys);
          state.totalItems = response.data.count || response.data.companys.length;
        }

        if (table === true && state.showTable === false) {
          state.showTable = true;
        }

        state.loadingTable = null;
        this.setState(state);

      })
      .catch(function () {
        let state = this.state;
        state.data = 'error';
        state.isSearching = false; // Finaliza o loading da pesquisa mesmo em caso de erro
        state.isPaginationLoading = false; // Finaliza o loading da paginação mesmo em caso de erro
        this.setState(state);
      }.bind(this));
    }

  }

  setColorStatus(companys) {
    let colors = {
      'AGUARDANDO PAGAMENTO': {color: configBase.bgPendentePJ, name: configBase.statusPendentePJ},
      'AGUARDANDO CONFIRMAÇÃO': {color: configBase.bgConfPendentePJ, name: configBase.statusConfPendentePJ},
      'EM PROCESSAMENTO': {color: configBase.bgEmProcessamentoPJ, name: configBase.statusEmProcessamentoPJ},
      'EM VALIDAÇÃO': {color: configBase.bgEmAnalisePJ, name: configBase.statusEmAnalisePJ},
      'PENDENTE': {color: configBase.bgIndeferidaPJ, name: configBase.statusIndeferidaPJ},
      'CANCELADO': {color: configBase.bgCanceladasPJ, name: configBase.statusCanceladasPJ},
      'ATIVO': {color: configBase.bgImplementadasPJ, name: configBase.statusImplementadasPJ},
    };
    let state = this.state;

    for (let i = 0; i < companys.length; i++) {
      // Verifica se o status existe no mapeamento, senão usa valores padrão
      if (colors[companys[i].status]) {
        companys[i].color = colors[companys[i].status].color;
        companys[i].status = colors[companys[i].status].name;
      } else {
        // Valores padrão para status não mapeados
        companys[i].color = configBase.bgPendentePJ || '#f0f0f0';
        companys[i].status = companys[i].status;
      }
    }

    state.data = companys;
  }

  sendDetails(companyId) {
    if (companyId != null) {
      this.props.history.push(`${process.env.PUBLIC_URL}/resumopj?p=${companyId}`);
    }
  }

  render() {

    return (
      <MainLayout history={this.props.history}>
        <div id="listaPropostas" className={{flexGrow: 1}}>
          <Paper elevation={0} className="paper">
            <Typography variant="button" gutterBottom>
              {this.state.titlePage}
            </Typography>
          </Paper>

          <div id="listaPropostaConteudo" className="contentepanel">
          
          {/* ############# CAMPO DE PESQUISA - SEMPRE VISÍVEL ############# */}
          {this.state.data !== 'loading' && (
            <div>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={2} lg={2}>
                  
                </Grid>
                <Grid item xs={12} sm={12} md={7} lg={7}></Grid>
                <Grid item xs={12} sm={12} md={3} lg={3} style={{marginBottom: 20, marginTop: 14}}>
                  <Paper elevation={1}>
                    <IconButton style={{padding: '6px 5px'}} aria-label="search">
                      <SearchIcon />
                    </IconButton>
                    <select
                      style={{
                        border: 'none',
                        background: 'transparent',
                        marginRight: '2px',
                        padding: '2px',
                        outline: 'none'
                      }}
                      onChange={(e) => {
                        this.setState({
                          searchField: e.target.value,
                          searchTerm: '' // Limpa o campo de busca ao trocar o tipo
                        });
                      }}
                    >
                      <option value="fantasyName">Empresa</option>
                      <option value="cnpj">CNPJ</option>
                      <option value="salesmanName">Vendedor</option>
                      <option value="proposalNumber">Proposta</option>
                    </select>
                    <InputBase
                      id="mySearchText"
                      style={this.styles.inputSearch}
                      placeholder="Pesquisar"
                      value={this.state.searchTerm || ''}
                      onChange={(e) => {
                        let searchValue = e && e.target ? e.target.value : '';
                        
                        // Aplica máscara se o campo de busca for CNPJ
                        if (this.state.searchField === 'cnpj') {
                          searchValue = this.applyCnpjMask(searchValue);
                        }
                        
                        // Reseta a paginação ao pesquisar
                        this.setState({
                          currentPage: 0,
                          searchTerm: searchValue,
                          isSearching: true // Ativa o loading
                        }, () => {
                          // Debounce para evitar muitas requisições
                          if (this.searchTimeout) {
                            clearTimeout(this.searchTimeout);
                          }
                          this.searchTimeout = setTimeout(() => {
                            this.getData(true, false);
                          }, 500);
                        });
                      }}
                      inputProps={{ 'aria-label': 'pesquisar propostas' }}
                    />
                  </Paper>
                </Grid>
              </Grid>
              
              {/* Loading durante pesquisa */}
              {this.state.isSearching && (
                <Grid container spacing={0} style={{marginTop: 10}}>
                  <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                  <Grid item xs={12} sm={12} md={8} lg={8}>
                    <LinearProgress />
                    <Typography variant="caption" display="block" style={{textAlign: 'center', marginTop: 5, color: '#757575'}}>
                      Pesquisando...
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                </Grid>
              )}
            </div>
          )}
          {/* ############# FIM CAMPO DE PESQUISA ############# */}

          {
          this.state.data === 'loading' ? (
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                <LinearProgress />
                <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                  BUSCANDO PROPOSTAS...
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
            </Grid>
          ) : (
            this.state.data === 'error' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="error">Problema ao buscar lista de propostas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
            ) : (
              this.state.data === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem propostas cadastradas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
              ) : (
                !this.state.isSearching && (
            <div id="listaPropostaTabela">
              {/* Loading indicator para paginação - aparece no lugar da tabela */}
              {this.state.isPaginationLoading && (
                <Grid container spacing={0} style={{marginTop: 40}}>
                  <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center'}}>
                    <LinearProgress />
                    <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                      CARREGANDO...
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                </Grid>
              )}
              {/* ############# CSS PARA DATATABLE ############# */}
              <link
                rel="stylesheet" type="text/css"
                href="https://cdnjs.cloudflare.com/ajax/libs/material-design-lite/1.1.0/material.min.css"
              />
              <link
                rel="stylesheet" type="text/css"
                href="https://cdn.datatables.net/1.10.19/css/dataTables.material.min.css"
              />
              {/* ############# CSS PARA DATATABLE ############# */}

              {
                this.state.loadingTable === 'loading' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} style={{textAlign: 'center', marginTop: 40}}>
                  <LinearProgress />
                  <Typography variant="overline" display="block" gutterBottom style={{marginTop: 10}}>
                    BUSCANDO PROPOSTAS...
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
                ) : (
                  this.state.loadingTable === 'zero' ? (
              <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Alert severity="info">Sem propostas cadastradas</Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={3} lg={3}>{''}</Grid>
              </Grid>
                  ) : (
                <div style={{display: this.state.isPaginationLoading ? 'none' : 'block'}}>  
                  <table id="table_id" className="mdl-data-table table-striped display nowrap" style={{width:'100%'}}>
                    <thead style={{backgroundColor: configBase.corPrincipal}}>
                      <tr style={this.styles.theadTr}>
                        <th style={this.styles.theadTh}>
                          <Typography
                            variant="button" display="block"
                            gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                          >
                            Data
                          </Typography>
                        </th>
                        <th style={this.styles.theadTh}>
                          <Typography
                            variant="button" display="block"
                            gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                          >
                            Empresa
                          </Typography>
                        </th>
                        <th style={this.styles.theadTh}>
                          <Typography
                            variant="button" display="block"
                            gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                          >
                            CNPJ
                          </Typography>
                        </th>
                        {
                          this.state.showColSalesman === true && (
                        <th style={this.styles.theadTh}>
                          <Typography
                            variant="button" display="block"
                            gutterBottom style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                          >
                            Vendedor
                          </Typography>
                        </th>
                          )
                        }
                        <th style={this.styles.theadTh}>
                          <Typography
                            variant="button" display="block" gutterBottom
                            style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                          >
                            Vidas
                          </Typography>
                        </th>
                        <th style={this.styles.theadTh}>
                          <Typography
                            variant="button" display="block" gutterBottom
                            style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                          >
                            Valor
                          </Typography>
                        </th>
                        <th style={this.styles.theadTh}>
                          <Typography
                            variant="button" display="block" gutterBottom
                            style={{color: configBase.corSecundaria, margin:0, fontSize: 8.5, fontWeight: 'bold'}}
                          >
                            Status
                          </Typography>
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                    {this.state.data.map((item, index) =>
                      <tr
                        id={'row_sales_'+item.salesId}
                        key={index}
                        className="row_table"
                        onClick={this.sendDetails.bind(this, item.id)}
                        style={{cursor:'pointer', height: 35, padding: 0}}
                      >
                        <td style={this.styles.tdDate}>
                          {item.dateFormat}
                        </td>

                        <td style={{padding: 0, height: 35}}>
                          <Typography
                            variant="overline" display="block" gutterBottom
                            style={{color: '#757575', margin:0, fontSize: 8.5}}
                          >
                            {item.fantasyName}
                          </Typography>
                        </td>

                        <td style={{padding: 0, height: 35}}>
                          <Typography
                            variant="overline" display="block" gutterBottom
                            style={{color: '#757575', margin:0, fontSize: 8.5}}
                          >
                            {item.cnpj}
                          </Typography>
                        </td>

                        {
                          this.state.showColSalesman === true && (
                        <td style={{padding: 0, height: 35}}>
                          <Typography
                            variant="overline" display="block" gutterBottom
                            style={{color: '#757575', margin:0, fontSize: 8.5}}
                          >
                            {item.salesman}
                          </Typography>
                        </td>
                          )
                        }

                        <td style={{padding: 0, height: 35}}>
                          <Typography
                            variant="overline" display="block" gutterBottom
                            style={{color: '#757575', margin:0, fontSize: 8.5}}
                          >
                            {item.lives}
                          </Typography>
                        </td>

                        <td data-order={item.value.replace(',', '')} style={{padding: 0, height: 35}}>
                          <Typography
                            variant="overline" display="block" gutterBottom
                            style={{color: '#757575', margin:0, fontSize: 8.5}}
                          >
                            {'R$ ' + item.value}
                          </Typography>
                        </td>

                        <td style={{padding: 0, height: 35, whiteSpace: 'nowrap'}}>
                          <Typography
                            variant="overline" display="block" gutterBottom
                            style={{color: '#757575', margin:0, marginRight: 5, fontSize: 8.5}}
                          >
                            <span
                              style={{padding: '5px 7px', border: '1px solid '+item.color, borderRadius: 5, color: item.color}}
                            >
                              {item.status}
                            </span>
                          </Typography>
                        </td>
                      </tr>
                    )}
                    </tbody>
                  </table>

                  <div style={{height: 48, backgroundColor: '#ffffff', color: '#707070', paddingTop: 14, borderTop: '2px solid #eee'}}>
                    <div style={{position: 'relative', float: 'right', right: 100, fontSize: 12}}>
                      <label htmlFor="itemsPerPage">Linhas por página: </label>
                      <select 
                        value={this.state.itemsPerPage}
                        onChange={(e) => {
                          this.setState({
                            itemsPerPage: parseInt(e.target.value),
                            currentPage: 0,
                            isPaginationLoading: true
                          }, () => this.getData(true, false));
                        }}
                        style={{background: 'transparent', border: 'none', marginLeft: 10, color: '#707070'}}
                      >
                        <option value="10">10</option>
                        <option value="35">35</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select>
                      <span style={{marginLeft: 15}}>
                        {this.state.currentPage * this.state.itemsPerPage + 1}-
                        {Math.min((this.state.currentPage + 1) * this.state.itemsPerPage, this.state.totalItems)}
                      </span>
                      {' '}de{' '}
                      <span>{this.state.totalItems}</span>
                      <button 
                        onClick={() => {
                          if (this.state.currentPage > 0) {
                            this.setState({
                              currentPage: this.state.currentPage - 1,
                              isPaginationLoading: true
                            }, () => this.getData(true, false));
                          }
                        }}
                        disabled={this.state.currentPage === 0}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: this.state.currentPage === 0 ? 'default' : 'pointer',
                          opacity: this.state.currentPage === 0 ? 0.5 : 1
                        }}
                      >
                        <svg className="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small">
                          <path d="M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
                        </svg>
                      </button>
                      <button 
                        onClick={() => {
                          if ((this.state.currentPage + 1) * this.state.itemsPerPage < this.state.totalItems) {
                            this.setState({
                              currentPage: this.state.currentPage + 1,
                              isPaginationLoading: true
                            }, () => this.getData(true, false));
                          }
                        }}
                        disabled={(this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems}
                        style={{
                          background: 'transparent',
                          border: 'none',
                          cursor: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 'default' : 'pointer',
                          opacity: (this.state.currentPage + 1) * this.state.itemsPerPage >= this.state.totalItems ? 0.5 : 1
                        }}
                      >
                        <svg className="MuiSvgIcon-root jss415 MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true" title="fontSize small">
                          <path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                  </div>
                  )
                )
              }     
            </div>
                )
              )
              )
            )
          }
          </div>
        </div>
      </MainLayout>
    );

  }

}

ListaPropostasPJ.propTypes = {
  history: PropTypes.object
};

export default withRouter(ListaPropostasPJ);